<template>
    <va-card class="margin-b-1">
        <va-card-content style="background: #fff; display: flex">
            <div style="flex: 8">
                <va-input
                    v-model="searchValue"
                    placeholder="搜索帖子或者问题..."
                    outline
                />
            </div>
            <div style="flex: 4">
                <!-- <router-link to="/admin/forum/searchPage"> -->
                <va-button
                    :rounded="false"
                    text-color="#ffffff"
                    icon-right="search"
                    style="border-radius: unset"
                    @click="searchClick"
                ></va-button>
                <!-- </router-link> -->
                <va-icon
                    name="menu"
                    size="36px"
                    color="blank"
                    @click="showFilter"
                    style="margin: 0 20px"
                />
                <router-link
                    :to="{ path: '/admin/forum/publishArticle' }"
                    tag="a"
                >
                    <va-button
                        class="flex xs14"
                        :rounded="false"
                        text-color="#ffffff"
                        icon-left="search"
                        >发布帖子</va-button
                    >
                </router-link>
            </div>
        </va-card-content>
        <va-card-content
            style="background: #fff; display: flex; align-items: center"
            v-if="isShowFilter"
        >
            <div class="flex md5 xs11" style="margin-right: 20px">
                <h2>筛选标签：</h2>
                <a-select
                    mode="multiple"
                    allowClear
                    v-model:value="tagValue"
                    notFoundContent="暂无数据"
                    optionLabelProp="label"
                    placeholder="请选择选项"
                    style="width: 100%"
                    :options="
                        options.map((item) => ({
                            label: item.Name,
                            value: item.ID,
                        }))
                    "
                >
                </a-select>
            </div>
            <div class="flex md5 xs11" style="margin-right: 20px">
                <h2>筛选分类：</h2>
                <a-cascader
                    :show-search="{ selectFilter }"
                    v-model:value="classValue"
                    @change="handleChange"
                    style="width: 100%"
                    placeholder="请选择分类"
                    notFoundContent="暂无数据"
                    :options="classOptions"
                    change-on-select
                    :fieldNames="{
                        label: 'Name',
                        value: 'ID',
                        children: 'Children',
                    }"
                />
            </div>
            <div class="flex md2 xs2">
                <a-checkbox v-model:checked="checked">仅精华帖</a-checkbox>
            </div>
        </va-card-content>
    </va-card>
    <div class="row row-equal">
        <div class="margin-b-1 flex xs15 md12 xl6">
            <va-card>
                <div style="display: flex">
                    <div>
                        <va-card-content>
                            <forum-content
                                :pushdata="forumSection"
                            ></forum-content>
                        </va-card-content>
                    </div>
                </div>
            </va-card>
        </div>
        <div class="margin-b-1 flex xs9 md12 xl7 mdjhjf">
            <va-card style="flex: 7">
                <div style="display: flex" class="mdjh">
                    <div style="width: 100%">
                        <va-card-content>
                            <invitation></invitation>
                        </va-card-content>
                    </div>
                </div>
            </va-card>
            <va-card style="flex: 5">
                <div style="display: flex">
                    <div style="width: 100%">
                        <va-card-content>
                            <grade></grade>
                        </va-card-content>
                    </div>
                </div>
            </va-card>
        </div>
    </div>
</template>

<script>
import forumContent from "./components/forumContent.vue"; //操作指南
import invitation from "./components/invitation.vue"; //精华帖子
import grade from "./components/grade.vue"; //积分榜
// import {getForumType} from './serviceData.js';//积分榜
import {
    computed,
    reactive,
    defineComponent,
    ref,
    toRaw,
    onMounted,
    getCurrentInstance,
    toRefs,
} from "vue";

import { useRouter } from "vue-router";
import Qs from "qs";
import { VXETable } from "vxe-table";
const classOptions = [];
const router = useRouter();
export default defineComponent({
    name: "forum",
    components: { forumContent, invitation, grade },
    setup() {
        const state = reactive({
            forumSection: [],
        });
        const selectFilter = (inputValue, path) => {
            return path.some(
                (option) =>
                    option.label
                        .toLowerCase()
                        .indexOf(inputValue.toLowerCase()) > -1
            );
        };

        // onMounted(async () => {
        //   const { proxy } = getCurrentInstance();
        //   let resData;

        //   const params = {
        //       "Name": "",
        //   };
        //   proxy.$api.formsAPI.getForumType(Qs.stringify(params))
        //     .then(res => {
        //       if (res.data.Success == false) {
        //         VXETable.modal.message({
         //                   content: res.data.Message,
          //                  status: "error",
           //             });
        //         return;
        //       }
        //       // this.forumTypeList = res.data.Data;
        //       resData = res.data.Data;
        //       console.log(resData)
        //     })
        //     .catch(error => {
        //       console.log(error);
        //     })
        //     state.forumSection = resData;
        //   // const { data } = await getForumType()
        //   // console.log(data)
        //   // Toast.clear()
        //   // state.categoryData = data
        // })

        const forumSection = reactive([]);
        // const state = reactive({
        //   forumSection: [],
        // })
        const options = [];
        const isShowFilter = ref(false);
        const showFilter = () => {
            isShowFilter.value = !isShowFilter.value;
        };
        const handleChange = (value) => {
            console.log(value);
        };
        return {
            selectFilter,
            handleChange,
            classValue: ref([]),
            options,
            tagValue: ref(),
            searchValue: ref(),
            classOptions,
            isShowFilter,
            checked: ref(),
            showFilter,
            multiSearchableSelectModel: "",
            forumTypeList: [],
            forumSection,
            ...toRefs(state),
        };
    },
    created() {
        this.getForumGategory();
        this.getForumLabel();
        // this.$store.commit('updatePostsRouterParam', {})

        // this.getForumType().then((ress) =>{
        //   // console.log(ress)
        //   this.getForumSection(ress)
        // })
        // this.$store.commit('updateSearchData',{});
    },
    methods: {
        searchClick() {
            let params = {
                SectionID: "", //版块ID
                Label: toRaw(this.tagValue), //标签ID，用‘,’隔开
                KeyWord: this.searchValue, //查询关键字，标题或内容
                Category: toRaw(this.classValue), //类别ID
                IsElite: this.checked, //1 精华；空或其他，全部
                Creator: "", //发布人UID
                TimeSpan: "", //0 今天 1 三天内 2 一周内 3 一月内 4 半年内
                Order: "", //0 最近更新 1 最新发布 2 点赞数 3 回复数
                currentPage: "1", //当前页
                pageSize: "10", //页大小
            };
            this.$store.commit("updateSearchData", JSON.stringify(params));
            this.$router.push({ path: "/admin/forum/searchPage" });
        },
        //获取板块类型
        getForumSection(paramData) {
            let resData,
                forumTypeList = paramData;
            const params = {
                Name: "",
            };
            this.$api.formsAPI
                .getForumSection(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    resData = res.data.Data;
                    paramData.map((item, index) => {
                        forumTypeList[index]["sectionList"] = [];
                        resData.forEach((itm, idx) => {
                            if (item.Name == itm.TypeName) {
                                forumTypeList[index]["sectionList"].push(itm);
                            }
                        });
                    });
                    this.forumSection = reactive({ forumTypeList });
                    console.log(toRaw(this.forumSection.forumTypeList));
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //获取论坛类型
        async getForumType() {
            let resData;
            const params = {
                Name: "",
            };
            await this.$api.formsAPI
                .getForumType(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.forumTypeList = res.data.Data;
                    resData = res.data.Data;
                })
                .catch((error) => {
                    console.log(error);
                });
            return resData;
        },
        //获取tab
        getForumLabel() {
            const params = {
                Name: "",
                IsTab: "",
                Remark: "1",
            };
            this.$api.formsAPI
                .getForumLabel(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.options = res.data.Data;
                    this.$store.commit("updateTabOptions", res.data.Data);
                    // console.log(this.$store.state.tabOptions)
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //获取分类
        getForumGategory() {
            const params = {
                Name: "",
            };
            this.$api.formsAPI
                .getForumGategory(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.classOptions = res.data.Data;

                    this.$store.commit("updateClassOptions", res.data.Data);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.searchClick();
            }
        },
    },
    mounted() {
        //从主页进帖子列表，清空缓存
        let forumPageData = {
            sectionID: "",
            sectionName: "",
            labelID: "",
            labelName: "",
            pageIndex: 1,
            pageSize: 10,
            TimeSpan: "0",
            Order: "0",
        };
        console.log("updateForumPageData index");
        console.log(forumPageData);
        this.$store.commit("updateForumPageData", forumPageData);
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
});
</script>
<style src="./css/antd.css"></style>
<style scoped>
.row-equal .flex .va-card {
    height: auto;
}

.margin-b-1 {
    margin-bottom: 1rem;
}

@media (min-width: 768px) {
    .invitation .link-a {
        max-width: none;
    }

    .flex.mdjhjf {
        display: flex;
    }

    .mdjhjf > div:first-child {
        margin-right: 24px;
    }
}

@media (min-width: 1200px) {
    .flex.mdjhjf {
        display: block;
    }

    .mdjh {
        margin-bottom: 24px;
    }

    .mdjhjf > div:first-child {
        margin-right: 0;
    }

    .flex.xl5 {
        flex-basis: 41.6666666667%;
        flex-grow: 0;
        max-width: 41.6666666667%;
    }

    .flex.xl4 {
        flex-basis: 33.3333333333%;
        flex-grow: 0;
        max-width: 33.3333333333%;
    }

    .flex.xl3 {
        flex-basis: 25%;
        flex-grow: 0;
        max-width: 25%;
    }

    .flex.xl6 {
        flex-basis: 70%;
        flex-grow: 0;
        max-width: 70%;
    }

    .flex.xl7 {
        flex-basis: 30%;
        flex-grow: 0;
        max-width: 30%;
    }
}
</style>
